<template>
  <v-container fluid id="profil-page-shops">
    <v-row>
      <v-col cols="12" class="text size-large weight-bold font-alt">
        Mettez à jour vos informations
      </v-col>
    </v-row>
    <v-row v-if="!scheduleApplicationReady && !applicationReady">
      <v-col cols="12" class=""> Loading ... </v-col>
    </v-row>
    <v-row
      v-if="
        scheduleApplicationReady &&
        applicationReady &&
        establishmentModel !== null
      "
      class="px-3 mt-8"
    >
      <v-col cols="12" class="colored-bg mb-5">
        <v-row class="pa-3 mb-1">
          <v-col
            sm="12"
            md="12"
            lg="5"
            :class="{
              'pr-3': $vuetify.breakpoint.md,
              'pr-7': $vuetify.breakpoint.lgAndUp,
            }"
          >
            <div class="pb-8 text-center text size-large font-weight-bold">
              Mon établissement
            </div>
            <v-card class="theme-card rounded">
              <SelectInput
                class="px-5 pt-5"
                v-model="establishmentModel.country"
                cols="6"
                :items="items"
                label="Pays"
                :placeholder="establishmentModel.country"
                single-line
                outlined
              />
              <v-row style="vertical-align: middle" class="pt-5 px-5">
                <TextInput
                  outlined
                  v-model="establishmentModel.city"
                  :placeholder="establishmentModel.city"
                  label="Ville"
                />
                <TextInput
                  outlined
                  v-model="establishmentModel.postal_code"
                  :placeholder="establishmentModel.postal_code"
                  label="Code Postale"
                />
              </v-row>
              <TextInput
                outlined
                class="px-5"
                v-model="establishmentModel.name"
                :placeholder="establishmentModel.name"
                label="Nom de l'établissement"
              />
              <TextInput
                outlined
                class="px-5"
                v-model="establishmentModel.address"
                :placeholder="establishmentModel.address"
                label="Adresse de l'établissement"
              />
              <!-- v-model="adresseInfo" -->
              <TextInput
                outlined
                class="px-5"
                placeholder="Complément d'adresse"
                label="Complément d'adresse"
              />
              <TextInput
                outlined
                class="pb-6 px-5"
                v-model="establishmentModel.surface"
                :placeholder="establishmentModel.surface"
                label="Surface de l'établissement"
              />
                <!-- <div v-if="!image">
                  <h2>
                    Choisissez un logo
                  </h2>
                    <input type="file" @change="onFileChange">
                  </div>
                  <div v-else>
                      <img :src="image" />
                    <button @click="removeImage">
                      Enlever le logo
                    </button>
                  </div> -->
              <v-row align="start" class="mx-4 mb-4">
                <v-col cols="12" class="py-2">
                  <v-file-input
                    placeholder="Chargez votre logo"
                    accept="image/png, image/jpeg, image/bmp"
                    hide-details=""
                    type="file"
                    @change="setEstablishmentLogoFile"
                  ></v-file-input>
                </v-col>
                <!-- <v-row align="start" class="mx-4 mb-4">
                  <v-col cols="12"  class="py-2">
                    <v-file-input
                      @input="(v) => updateScenarioContentData('compagny_logo', v)"
                      placeholder="Chargez votre logo"
                      accept="image/png, image/jpeg, image/bmp"
                      hide-details=""
                      type="file"
                    ></v-file-input>
                  </v-col>
                </v-row> -->
              </v-row>
              <v-divider></v-divider>
              <div class="px-5 pb-9 pt-8">
                <div class="addSellPoint">
                  <div class="sellPointButton pa-7">
                    <v-btn
                      height="98"
                      width="100%"
                      color="white"
                      @click="saveEstablishment"
                    >
                      <!-- <span 
												class="material-icons-outlined"
											>add</span> -->
                      <!-- <p class="addButtonText mb-0 ml-6 text weight-bold">
												Ajouter un autre point de vente
											</p> -->
                      <p class="addButtonText mb-0 ml-5 text weight-bold">
                        Sauvegarder
                      </p>
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col
            sm="12"
            md="12"
            lg="7"
            :class="{
              'pl-3': $vuetify.breakpoint.md,
              'pl-7': $vuetify.breakpoint.lgAndUp,
            }"
          >
            <div class="pb-8 text-center text size-large font-weight-bold">
              Horaires d'ouverture
            </div>
            <v-card class="theme-card rounded pt-5">
              <div v-for="(day, index) in days" :key="index">
                <day-block
                  :day="day.label"
                  :value="day.model"
                  @input="(v) => getHour(index, v)"
                />
              </div>
              <v-btn
                x-large
                class="majBtn pt-3"
                elevation="0"
                @click="saveSchedule"
              >
                <p class="">METTRE À JOUR</p>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script type="text/javascript">
import TextInput from "@/components/input/textInput";
import SelectInput from "@/components/input/selectInput";
import DayBlock from "@/components/ui/day-block.vue";

export default {
  components: {
    TextInput,
    SelectInput,
    DayBlock,
  },
  data() {
    return {
      establishmentModel: null,
      scheduleEstablishmentModel: [],
      updateDayIndex: [],
      image: "",
      days: [
        {
          label: "Lundi",
          model: {
            day: "Lundi",
            opening_hours: "",
            hour_break_start: "",
            hour_break_end: "",
            closing_hours: "",
            is_open: false,
            midday_break: false,
          },
        },
        {
          label: "Mardi",
          model: {
            day: "Mardi",
            opening_hours: "",
            hour_break_start: "",
            hour_break_end: "",
            closing_hours: "",
            is_open: false,
            midday_break: false,
          },
        },
        {
          label: "Mercredi",
          model: {
            day: "Mercredi",
            opening_hours: "",
            hour_break_start: "",
            hour_break_end: "",
            closing_hours: "",
            is_open: false,
            midday_break: false,
          },
        },
        {
          label: "Jeudi",
          model: {
            day: "Jeudi",
            opening_hours: "",
            hour_break_start: "",
            hour_break_end: "",
            closing_hours: "",
            is_open: false,
            midday_break: false,
          },
        },
        {
          label: "Vendredi",
          model: {
            day: "Vendredi",
            opening_hours: "",
            hour_break_start: "",
            hour_break_end: "",
            closing_hours: "",
            is_open: false,
            midday_break: false,
          },
        },
        {
          label: "Samedi",
          model: {
            day: "Samedi",
            opening_hours: "",
            hour_break_start: "",
            hour_break_end: "",
            closing_hours: "",
            is_open: false,
            midday_break: false,
          },
        },
        {
          label: "Dimanche",
          model: {
            day: "Dimanche",
            opening_hours: "",
            hour_break_start: "",
            hour_break_end: "",
            closing_hours: "",
            is_open: false,
            midday_break: false,
          },
        },
      ],
      items: ["France", "Angleterre"],
    };
  },

  created() {
    this.$store.dispatch("establishment/establishmentData", {
      success: () => {
        this.establishmentModel = Object.assign({}, this.establishment);

        this.$store.dispatch("establishment/scheduleEstablishmentData", {
          params: this.establishmentModel.id,
          success: (response) => {
            this.scheduleEstablishmentModel = Object.assign(
              {},
              this.scheduleEstablishment
            );
            if (response.length > 0) {
              for (var i = 0; i < response.length; i++) {
                this.days[i].model.opening_hours = response[i].opening_hours;
                this.days[i].model.hour_break_start =
                  response[i].hour_break_start;
                this.days[i].model.hour_break_end = response[i].hour_break_end;
                this.days[i].model.closing_hours = response[i].closing_hours;
                this.days[i].model.midday_break = response[i].midday_break;
                this.days[i].model.is_open = response[i].is_open;
              }
              return this.days;
            } else {
              return this.initScheduleEstaModel();
            }
          },
        });
      },
    });
  },
  methods: {
    getHour(dayIndex, value) {
      if (!this.updateDayIndex.includes(dayIndex)) {
        this.updateDayIndex.push(dayIndex);
      }
      Object.assign(value, this.days[dayIndex].model);
      return this.days;
    },

    saveSchedule() {
      const schedule = [];
      this.days.map((item, index) => {
        const frDays = [
          "Lundi",
          "Mardi",
          "Mercredi",
          "Jeudi",
          "Vendredi",
          "Samedi",
          "Dimanche",
        ];
        const enDays = [
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY",
          "SUNDAY",
        ];
        if (item.model.day === frDays[index]) {
          item.model.day = enDays[index];
          this.updateDayIndex.map((dayIndex) => {
            if (index == dayIndex) {
              schedule.push(item.model);
            }
          });
        }
      });
      if (this.scheduleEstablishmentModel.day === "") {
        this.$store.dispatch("establishment/createScheduleEstablishment", {
          parameters: schedule,
          success: (response) => {
            this.scheduleEstablishmentModel = Object.assign(
              {},
              this.scheduleEstablishment
            );
          },
        });
      } else {
        this.$store.dispatch("establishment/updateScheduleEstablishment", {
          parameters: schedule,
          establishment_id: this.scheduleEstablishmentModel.id,
          success: (response) => {
            this.scheduleEstablishmentModel = Object.assign(
              {},
              this.scheduleEstablishment
            );
          },
        });
      }
    },

    saveEstablishment() {
      console.info('saveEsta', this.establishmentModel);
      if (this.establishmentModel.id === null) {
        this.$store.dispatch("establishment/createEstablishment", {
          parameters: this.establishmentModel,
          success: (response) => {
            this.establishmentModel = Object.assign({}, this.establishment);
          },
        });
      } else {
        this.$store.dispatch("establishment/updateEstablishment", {
          parameters: this.establishmentModel,
          success: (response) => {
            this.establishmentModel = Object.assign({}, this.establishment);
          },
        });
      }
    },

    initScheduleEstaModel() {
      this.days.map((day) => {
        day.model.opening_hours = "";
        day.model.hour_break_start = "";
        day.model.hour_break_end = "";
        day.model.closing_hours = "";
        day.model.midday_break = false;
        day.model.is_open = false;
      });
    },

    setEstablishmentLogoFile(file) {
      this.establishmentModel.compagny_logo = file;
    },
  },

  computed: {
    applicationReady() {
      return this.$store.state.establishment.loaded;
    },
    scheduleApplicationReady() {
      return this.$store.state.establishment.scheduleLoaded;
    },
    managerId() {
      return this.$store.state.auth.users.data.user_id;
    },
    establishment() {
      return this.$store.state.establishment.establishment;
    },
    scheduleEstablishment() {
      return this.$store.state.establishment.scheduleEstablishment;
    },
  },
};
</script>

<style lang="scss">
.addSellPoint {
  height: 155px;
  width: 100%;
  background-color: #f9fafe;
  border: 2px dashed;
  border-color: $purple-alt;
  border-radius: 5px !important;
}

.addButtonText {
  color: $color-secondary;
  text-transform: none !important;
}
.material-icons-outlined {
  color: $color-secondary;
  font-size: 38px;
}
.majBtn {
  padding-top: 18px;
  height: 60px;
  width: 100%;
  background-color: $purple-alt;
}
</style>